import JockeyIconImage from "@/../public/icons/jockey.png";
import Image from "next/image";

export function JockeyIcon({ size }: { size: "small" | "medium" | "large" }) {
  const dimensions = size === "small" ? 20 : size === "medium" ? 24 : 60;
  return (
    <Image
      src={JockeyIconImage}
      width={dimensions}
      height={dimensions}
      alt="Off The Track"
    />
  );
}
